import { useTeamHistoryQuery, useTeamQuery } from '@common/cache';
import { useContext, useEffect, useState } from 'react';
import { AdminPanelDrawerContext } from '@views/pages/Admin/context';

interface IUseTeamProps {
  id: string;
  handleClose: () => void;
}

const historyTabIndex = '3';

export const useTeamDrawer = ({ id, handleClose }: IUseTeamProps) => {
  const { data: teamData } = useTeamQuery({
    teamId: id,
  });
  const [historyPage, setHistoryPage] = useState(1);
  const {
    isFormClean,
    handleClear,
    handleCloseTrigger,
    tabIndex,
    handleTriggerChangeTab,
    triggerClose,
  } = useContext(AdminPanelDrawerContext);

  const teamHistory = useTeamHistoryQuery({
    team_id: id,
    page: historyPage,
    limit: 100,
    enabled: historyTabIndex === tabIndex,
  });

  useEffect(() => {
    if (isFormClean && triggerClose) {
      handleClose();
      handleClear();
    }
  }, [isFormClean, triggerClose]);

  return {
    teamData,
    teamHistory: teamHistory.data,
    historyPage,
    setHistoryPage,
    handleCloseTrigger,
    tabIndex,
    handleTriggerChangeTab,
    historyTabIndex,
  };
};
